import API from './api';

export class CloudSearchAPICall {

    async getSearchCategory(searchValue, suggester, industryTypes, callback) {
        const response = await API.searchPropertyByCategory(searchValue, suggester, industryTypes, callback);
        if (response) {
            return callback(response);
        }
    }

    async getBoundingBox(geofields, upperLeft, lowerRight, industryTypes, callback) {
        const response = await API.searchByBoundingBox(geofields, upperLeft, lowerRight, industryTypes, callback);
        if (response) {
            return callback(response);
        }
    }

    async getBusinessName(nameOfBusiness, addressOfBusiness, searchValue, storedSuggesters, industryTypes, callback) {
        const response = await API.searchPropertyByBusinessName(nameOfBusiness, addressOfBusiness, searchValue, storedSuggesters, industryTypes, callback);
        if (response) {
            return callback(response);
        }
    }

    async getSuggester(searchBusiness, callback) {
        const {response, suggester} = await API.getSuggestedProperties(searchBusiness, callback);
        if (response) {
            return callback(response);
        }
    }
    
    async getNameSuggester(value, searchValue, suggesterValue, industryTypes, callback) {
        const response = await API.searchSuggester(value, searchValue, suggesterValue, industryTypes, callback);
        if (response) {
            return callback(response);
        }
    }
}